export default "{\n    \"label\": \"Instalación\",\n    \"placeholder\": \"Seleccione instalación\"\n}"